<template>
  <section class="px-4 py-12 md:py-20 flex flex-col items-center">
    <div class="w-full max-w-3xl flex flex-col items-center text-center gap-6">
      <h1>{{ t('landing.hero.title') }}</h1>

      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">
        {{ t('landing.hero.subline') }}
      </p>

      <PodcastSearchForm
        :loading="loading"
        :submit-label="t('landing.hero.submit')"
        @search="emit('search', $event)"
      />

      <p class="text-sm text-neutral-300">{{ t('landing.hero.trust') }}</p>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import PodcastSearchForm from '@/components/podcasts/PodcastSearchForm.vue'

defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'search', term: string): void
}>()

const { t } = useI18n()
</script>
